<template>
  <PageHeader :title="report.title" :subtitle="`Generated on ${formattedDate}`" :back-route="backRoute">
    <AppButton variant="primary" size="large" @click="$emit('export')">
      <AppIcon color="white" type="download" size="26" class="mr-8px" />
      Export report
    </AppButton>
  </PageHeader>
</template>

<script setup>
import { computed } from "vue";
import { AppButton, AppIcon } from "@/components/ui";
import { formatHumanFriendlyDate } from "@/utilities/date";
import PageHeader from "@/components/PageHeader.vue";

const props = defineProps({
  report: {
    type: Object,
    required: true,
  },
  backRoute: {
    type: Object,
    required: true,
  },
});

defineEmits(["export"]);

const formattedDate = computed(() => formatHumanFriendlyDate(props.report.updated_at || ""));
</script>
